import type { StateValue } from '@autobid/nuxt-pinia-store/types/Search'
import { storeToRefs } from 'pinia'
import { computed, inject } from 'vue'
import { useSearchStore } from './useSearchStore'

export function useFormGroupItem(groupKey: string, key: string | number) {
  const { debounced } = storeToRefs(useSearchStore())
  const { updateSearchValues } = useSearchStore()
  const title: string = inject('title', '')
  const route = useRoute()

  const getCurrentValue = () => {
    const value = route.query[groupKey]

    if (!value)
      return false

    if (!Array.isArray(value)) {
      return value === key.toString()
    }

    return value.map(item => String(item)).includes(key.toString())
  }

  const getFilterValue = () => {
    const value = route.query[groupKey]

    if (!value)
      return []

    const valueToFilter = Array.isArray(value) ? value : [value]

    return valueToFilter.filter(item => String(item) !== key.toString())
  }

  const value = computed({
    get: () => {
      return getCurrentValue()
    },
    set: () => {
      debounced.value = false
      const checked = getCurrentValue()
      const filtered = getFilterValue()

      if (checked) {
        updateSearchValues({ key: groupKey, value: filtered as StateValue, title })
        return
      }

      const value = [...filtered, key]

      updateSearchValues({ key: groupKey, value: value as StateValue, title })
    },
  })

  return value
}
